var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scrollMain",
      class: [_vm.language == "en" ? "en" : "", "app-container-sitc"],
      staticStyle: { "padding-bottom": "0px", "padding-top": "0px" },
    },
    [
      _c(
        "div",
        {
          staticClass: "container-content filter-container-content",
          staticStyle: { height: "48px", display: "flex" },
        },
        _vm._l(_vm.navTabList, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "tab_text",
              class: { selected: _vm.selectedIndex === index },
              on: {
                click: function ($event) {
                  return _vm.selectTab(index)
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.language === "zh" ? item.name : item.nameEn) +
                  "\n      "
              ),
              index < 4
                ? _c("div", { staticClass: "tab_text_border" })
                : _vm._e(),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticStyle: { "margin-top": "60px" },
          attrs: {
            inline: true,
            rules: _vm.rules,
            "label-position": "top",
            model: _vm.form,
            disabled: _vm.isDisable,
          },
        },
        [
          _c("bookingMainTemplate", {
            ref: "bookingMainTemplate",
            attrs: {
              id: "basicInfo",
              form: _vm.form,
              rules: _vm.rules,
              packageTypeList: _vm.packageTypeList,
              paidTypeList: _vm.paidTypeList,
              cargoList: _vm.cargoList,
              bookingTypeList: _vm.bookingTypeList,
              transportationTermsList: _vm.transportationTermsList,
            },
          }),
          _vm._v(" "),
          !_vm.showDisplay
            ? _c(
                "div",
                {
                  staticClass: "filter-container-content",
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { id: "consignerInfo" },
                  on: {
                    click: function ($event) {
                      _vm.showDisplay = !_vm.showDisplay
                    },
                  },
                },
                [
                  _c("div", { staticClass: "filter-container-title" }, [
                    _vm._v(_vm._s(_vm.$t("home.displayButton"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "consignerInfo-button" }, [
                    _vm._v(_vm._s(_vm.$t("home.displayOpen"))),
                    _c("i", { staticClass: "el-icon-arrow-down" }),
                  ]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "filter-container-content",
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { id: "consignerInfo" },
                  on: {
                    click: function ($event) {
                      _vm.showDisplay = !_vm.showDisplay
                    },
                  },
                },
                [
                  _c("div", { staticClass: "filter-container-title" }, [
                    _vm._v(_vm._s(_vm.$t("home.hideButton"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "consignerInfo-button" }, [
                    _vm._v(_vm._s(_vm.$t("home.displayClose"))),
                    _c("i", { staticClass: "el-icon-arrow-up" }),
                  ]),
                ]
              ),
          _vm._v(" "),
          _vm.showDisplay
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("consignerInfo", {
                      ref: "consignerInfo",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                    _vm._v(" "),
                    _c("consignerReceiveInfo", {
                      ref: "consignerReceiveInfo",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-between",
                    },
                  },
                  [
                    _c("consignerInfoOne", {
                      ref: "consignerInfoOne",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                    _vm._v(" "),
                    _c("consignerInfoTwo", {
                      ref: "consignerInfoTwo",
                      staticStyle: { width: "49%" },
                      attrs: {
                        isDisable: this.isDisable,
                        isShowRequired: false,
                        form: _vm.form,
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("bookCargo", {
            ref: "bookCargo",
            attrs: {
              isDisable: this.isDisable,
              isShow: false,
              isShowRequired: false,
              id: "cargoInfo",
              "show-cargo-info": true,
              formInfo: _vm.form,
              rules: _vm.rules,
            },
            on: { openDialog: _vm.openDialog },
          }),
          _vm._v(" "),
          _c("dropTitle", {
            ref: "dropTitle",
            attrs: {
              id: "boxInfo",
              showdisabled: false,
              form: _vm.form,
              rules: _vm.rules,
              containerTypeList: _vm.containerTypeList,
              cargoList: _vm.cargoList,
            },
          }),
          _vm._v(" "),
          _c("bookInfo", {
            ref: "bookInfo",
            attrs: {
              id: "otherInfo",
              showdisabled: false,
              form: _vm.form,
              rules: _vm.rules,
              fullEmptyTypeList: _vm.fullEmptyTypeList,
              containerSizeList: _vm.containerSizeList,
              containerTypeList: _vm.containerTypeList,
              contactTypeCodeList: _vm.contactTypeCodeList,
              lineTypeList: _vm.lineTypeList,
              directionList: _vm.directionList,
              packageDescList: _vm.packageDescList,
              packageTypeList: _vm.packageTypeList,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            height: "50px",
            "line-height": "50px",
            background: "#fff",
            "padding-left": "20px",
          },
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-primary",
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleSave(11)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("home.buttonAdd")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "btn-plain-primary",
              on: { click: _vm.handleCloseLast },
            },
            [_vm._v(_vm._s(_vm.$t("home.close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("MessageInputText", {
        ref: "myDialog",
        attrs: { catalogContent: _vm.dialogContent },
        on: {
          "update:catalogContent": function ($event) {
            _vm.dialogContent = $event
          },
          "update:catalog-content": function ($event) {
            _vm.dialogContent = $event
          },
          confirm: _vm.confirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }